import React, { useState, FunctionComponent, useEffect } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';
import styles from './pageDisplay.module.css';
import { Pagination } from '@mantine/core';

const buildNumberArray = (start, end) => {
  const arr = [];
  for (let i = start; i <= end; i++) {
    arr.push(i);
  }
  return arr;
};

export const PageDisplay = (props) => {
  const [totalPages, setTotalPages] = useState(0);
  // const [currentPage, setCurrentPage] = useState(props.currentPage);

  const handlePageChange = (newPageNumber) => {
    props.setPageNumber(newPageNumber);
  };

  const generatePageCounter = (currentPage) => {
    currentPage = parseInt(currentPage);
    const startPage = currentPage - 2 > -1 ? currentPage - 2 : 0;
    const endPage = currentPage + 2 < totalPages ? currentPage + 2 : totalPages;
    const pages = buildNumberArray(startPage, endPage);
    return pages.map((page) => {
      const style =
        page === currentPage ? styles.currentPage : styles.pageNumber;
      return (
        <span>
          <button
            onClick={(ele) => {
              try {
                const possibleNumber = ele.target.innerHTML.split('<h3>')[0];
                if (parseInt(possibleNumber)) {
                  props.setPageNumber(possibleNumber);
                  return;
                }

                const correctNumber = ele.target.innerHTML
                  .split('<h3>')[1]
                  .split('</h3>')[0];

                props.setPageNumber(correctNumber);
              } catch (error) {
                console.error(error);
                props.setPageNumber(0);
              }
            }}
            className={style}
          >
            <h3>{page}</h3>
          </button>
        </span>
      );
    });
  };

  const calculatePages = (totalNumberOfBans) => {
    const hitsPerPage = 25;
    setTotalPages(Math.floor(parseInt(totalNumberOfBans) / hitsPerPage));
  };

  useEffect(() => {
    calculatePages(props.totalNumberOfBans);
  }, [props.totalNumberOfBans]);

  return (
    <div title="PageDisplay">
      <Pagination
        total={totalPages}
        onChange={handlePageChange}
        page={props.pageNumber}
      />
      ;
    </div>
  );
};
